// 大小写字母 + 数字 并且长度 大于等于 11 位
export const PWDREG = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[A-Za-z0-9]).{11,}/;



// 连续字符
export const continueTest = (str) => {
  if(!str?.length) return true;
  for (let i = 1; i < str.length - 1; i++) {
    let preStr = str[i - 1]?.charCodeAt();
    let currStr = str[i]?.charCodeAt();
    let nexStr = str[i + 1]?.charCodeAt();

    if ((currStr - preStr === 1) && (nexStr - currStr === 1)) {
      return false;
    };
  };

  return true;
};